<template>
    <div class="notice-rule">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入告警站点" :search-submit="$_getTableList"></mc-search-bar>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.begin_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item" @click="dialog.siteName.methods.open(scope.row)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">成功</span>
                        <span v-else-if="scope.row.status == 1">失败</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.method == 0"></span>
                        <!-- <span v-else-if="scope.row.method == 1">正常</span> -->
                        <span v-else-if="scope.row.method == 2">微信</span>
                        <!-- <span v-else-if="scope.row.method == 3">紧急</span> -->
                        <span v-else-if="scope.row.method == 4">APP</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span @click="dialog.content.methods.open(scope.row)" class="deal-item content">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="notice-rule-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.siteName">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="120">
                    <mc-label info>{{site.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="120">
                    <mc-label info>{{site.province}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="120">
                    <mc-label info>{{site.city}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="地址" :labelWidth="120">
                    <mc-label info>{{site.address}}</mc-label>
                </mc-layout-row>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.content">
            <template slot="content">
                <mc-label info>{{this.dialog.content.data.content}}</mc-label>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "user-notice-rule",
        data() {
            return {
                searchParmas: '',
                site: [],
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "begin_at",
                            label: "通知时间",
                            width: "200",
                        },
                        {
                            prop: "site_name",
                            label: "告警站点",
                            width: "",
                        },
                        {
                            prop: "host",
                            label: "告警对象",
                            width: "250",
                        },
                        {
                            prop: "status",
                            label: "通知状态",
                            width: "100",
                        },
                        {
                            prop: "method",
                            label: "通知方式",
                            width: "100",
                        },
                        {
                            prop: "content",
                            label: "通知内容",
                            width: ""
                        },
                    ],
                    data: [],
                },
                dialog: {
                    siteName: {
                        visible: false,
                        title: "站点详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (row) => {
                                this.dialog.siteName.data.id = row.site_id;
                                this.$_getSite(row.site_id);
                                this.dialog.siteName.visible = true;
                            },
                        },
                        data: {
                            id: "",
                        },
                    },
                    content: {
                        visible: false,
                        title: "通知内容",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.content.visible = true;
                                this.dialog.content.data.content = item.content;
                            },
                        },
                        data: {
                            content: "",
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    sitename: this.searchParmas
                }
                let data = await this.$api.userNoticeRule.getList.getNoticeRuleList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getSite: async function () {
                let params = {
                    site_id: this.dialog.siteName.data.id
                }
                let data = await this.$api.userNoticeRule.getList.getSite.call(this, params);
                if (data !== false) {
                    this.site = data[0];
                }
            },
            $_handleTime(time) {
                // let date = time.replace('T', " ");
                // return date;
                let time1 = time.replace('T', " ");
                let origindate = Date.parse(time1);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .notice-rule {
        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .content {
            min-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .site-content {
            display: inline-flex;
            width: 100%;
            margin-bottom: 10px;

            .site-content-item {
                flex: 1
            }
        }
    }
</style>